export enum Form {
    FILTER = "FILTER",
    SIGN_IN = "SIGN_IN",
    BOOKING = "BOOKING",
    PROFILE = "PROFILE",
    SUPPORT = "SUPPORT",
    TICKET = "TICKET",
    PAYMENT = "PAYMENT",
    SAFAR30 = "SAFAR30",
    REQUEST = "REQUEST",
}

export enum TravelMod {
    NEW = "NEW",
    MY = "MY",
}

export enum Message {
    VERIFY_CODE_SENT = "VERIFY_CODE_SENT",
    SIGN_IN_PROFILE = "SIGN_IN_PROFILE",
    SIGN_OUT_PROFILE = "SIGN_OUT_PROFILE",
    UPDATE_PROFILE = "UPDATE_PROFILE",
    CREATE_REQUEST = "CREATE_REQUEST",
    ERROR_SEARCH = "ERROR_SEARCH",
    ERROR_REQUEST = "ERROR_REQUEST",
    TICKET_CANCEL = "TICKET_CANCEL",
}

export enum Capacity {
    ONE = "ONE",
    TWO = "TWO",
    THREE = "THREE",
}

export enum Bank {
    Saman = 'SAMAN',
    MehrIran = 'MEHR_IRAN',
    Refah = 'REFAH',
    Saderat = 'SADERAT',
    ToseTaavon = 'TOSE_TAAVON',
    Khavaremiyaneh = 'KHAVAREMIYANEH',
    PostBank = 'POST_BANK',
    Gardeshgari = 'GARDESHGARI',
    Sina = 'SINA',
    Sepah = 'SEPAH',
    Tejarat = 'TEJARAT',
}

export enum Payment {
    Sep = 'SEP',
    Pep = 'PEP',
    Zarinpal = 'ZARINPAL',
    Cash = 'CASH',
    Credit = 'CREDIT',
}

export enum TravelType {
    Person = 'PERSON',
    Close = 'CLOSE',
    Home = 'HOME',
}